import React, { Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import { RoleBasedRouting } from './_routes/PrivateRoute'
import { Roles } from './_constants'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))

const App = () => {
  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route
            element={
              <RoleBasedRouting
                roles={[Roles.ROLE_USER, Roles.ROLE_ADMIN, Roles.ROLE_ADMIN_DEMO]}
              />
            }
          >
            <Route path="*" element={<DefaultLayout />} />
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default React.memo(App)
